import React from 'react'
import FeesCollction from './FeesCollction';
import AddFeesCollection from './AddFeesCollection';
import ViewFeesCollection from './ViewFeesCollection';
import EditFeesCollection from './EditFeesCollection';
import { Routes, Route } from "react-router-dom";

const MainFeesCollection = () => {
  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
          <Route path='/' element={<FeesCollction/>}></Route>
          <Route path='/add-fees-collection' element={<AddFeesCollection/>}></Route>
          <Route path='/view-fees-collection' element={<ViewFeesCollection/>}></Route>
          <Route path='/edit-fees-collection' element={<EditFeesCollection/>}></Route>
      </Routes>
    </div>
  )
}

export default MainFeesCollection
